import { render, staticRenderFns } from "./OnboardingRequestForm.vue?vue&type=template&id=3459a61a&"
import script from "./OnboardingRequestForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports